import React, { useState } from 'react';
import './Select.scss';

const Select = ({ options, onChange, title }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        onChange(option);
        setIsOpen(false);
    };

    console.log("Select options:", options);
    return (
        <div className="custom-select">
            <div className="select-header" onClick={handleToggle}>
                {/* {selectedOption ? selectedOption : 'Select a car'} */}
                {title || 'Select an option'}
                <span className="arrow">{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <ul className="select-options">
                    {options.sort().map((option, index) => (
                        <li key={index} className="select-option" onClick={() => handleOptionClick(option)}>
                            {option}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Select;